'use strict';

var templates = require('../theme/templates');

module.exports = function template(templateName, data) {
    return templates[templateName](data);
};

// Workaround for IE 8's lack of support
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/template.js
 ** module id = 6
 ** module chunks = 0
 **/